import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
  transform(array: any[], field: string): any[] {
    if (!Array.isArray(array)) {
      return [];
    }

    return array.sort((a: any, b: any) => {
      const aValue = a && a[field] ? a[field] : '';
      const bValue = b && b[field] ? b[field] : '';

      // Handle string comparison
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return aValue.localeCompare(bValue);
      }

      // Handle numeric comparison
      return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    });
  }
}
